var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"user-avatar",class:{ 'user-avatar-onair': _vm.onair }},[(_vm.src && !_vm.failed)?_c('img',{staticClass:"user-avatar-img",attrs:{"src":_vm.src,"alt":_vm.name || 'avatar'},on:{"error":function($event){_vm.failed = true}}}):_c('span',{staticClass:"user-avatar-text"},[_vm._v(_vm._s(_vm.firstChar))])])
}
var staticRenderFns = []

export { render, staticRenderFns }